import { API_ORIGIN } from '@/constants'
import { authorizedFetch } from '@/lib/api'

export async function withdrawApplication(applicationId: string): Promise<void> {
  const response = await authorizedFetch(
    `${API_ORIGIN}/api/applications/${encodeURIComponent(applicationId)}/withdraw/`,
    {
      method: 'POST',
      body: JSON.stringify({}),
    },
  )
  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error((error as { error?: string }).error || 'Could not withdraw application')
  }
}
